module.exports = __webpack_public_path__ + "static/media/generalSurgery-image3.cb41b593.png";